// adding must contain a letter validation

const rule = {
	name: 'containsAtLeastOneLetter',
	method: (value, element, params) => /[a-zA-Z]/.test(value),
	errorMessage: (params, element) => 'Your password must contain at least one letter'
};

export default rule;
